import { pxToRem } from 'styles/functions'

const Theme = {
  body_background_color: '#FFFFFF',

  logo_image_url: 'bromont.jpg',
  header_full_height: true,

  
  number_hidden: 'true',
  token_hidden: 'false',

  button_color: '#000000',
  button_radius: 50,
  button_font: `'Montserrat', sans-serif`,
  button_text_size: 15,
  button_text_weight: 600,
  button_padding: `${pxToRem(10)} ${pxToRem(20)}`,

  button_half_border_color: '#000000',
  button_half_text_size: 14,

  text_font: `'Montserrat', sans-serif`,
  text_size: 14,

  title_font: `'Pathway Gothic One', sans-serif`,
  title_size: 36,

  subtitle_size: 28,
  subtitle_lineheight: 32,
}

export default Theme
